var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnnumberedListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#6A84C5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 16",
    cx: 2,
    cy: 7,
    r: 2,
    fill: "#6A84C5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 17",
    cx: 2,
    cy: 12,
    r: 2,
    fill: "#6A84C5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 62",
    x: 6,
    y: 1,
    width: 9,
    height: 2,
    fill: "#6A84C5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 63",
    x: 6,
    y: 1,
    width: 9,
    height: 2,
    fill: "#6A84C5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 64",
    x: 6,
    y: 6,
    width: 9,
    height: 2,
    fill: "#6A84C5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 65",
    x: 6,
    y: 11,
    width: 9,
    height: 2,
    fill: "#6A84C5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnnumberedListIcon);
export default __webpack_public_path__ + "static/media/unnumbered-list-icon.aa1374183c9247427f04c8fb67d1e327.svg";
export { ForwardRef as ReactComponent };